export default () => {
  (function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      define([], factory(root));
    } else if (typeof exports === 'object') {
      module.exports = factory(root);
    } else {
      root.contactZalo = factory(root);
    }
  })(typeof global !== "undefined" ? global : this.window || this.global, function (root) {
    var contactZalo = {};
    var rootElement = document.querySelector('.c-zalo');
    var defaults = {
      rootElementId: 'c-zalo',
    };

    var initPrompt = function () {
      var $container = createElement('div', {
        classes: ['c-zalo-show']
      });
      var $inner = createElement('div', {
        classes: ['c-zalo-text'],
      });

      $container.append($inner);

      rootElement.append($container);
    };

    var createElement = function (tag, options, content) {
      var el = document.createElement(tag);
      if (options) {
        if (options.classes) {
          if (typeof (options.classes) === 'object') {
            for (var i in options.classes) {
              if (options.classes[i]) {
                if (typeof options.classes[i] === 'string') {
                  el.classList.add(options.classes[i]);
                }
              }
            }
          }
        }
        for (var i in options) {
          if (i !== 'classes' && options[i] && (typeof options[i] === 'string')) {
            el.setAttribute(i, options[i]);
          }
        }
      }
      if (typeof (content) !== 'undefined') {
        el.innerHTML = content;
      }
      return el;
    };


    var showPrompt = function (data) {
      var $promptContainer = rootElement.querySelector('.c-zalo-show');
      if (data && data.content) {
        $promptContainer.querySelector('.c-zalo-text').innerHTML = data.content;
      }
      $promptContainer.classList.add('active');
      var e = new Event('zalo.showPrompt');
      rootElement.dispatchEvent(e);
    };

    var hidePrompt = function () {
      var $promptContainer = rootElement.querySelector('.c-zalo-show');
      var $unreadContainer = rootElement.querySelector('.c-zalo-unread');
      $promptContainer.classList.remove('active');
      $unreadContainer.classList.remove('d-none');
      var e = new Event('zalo.hidePrompt');
      rootElement.dispatchEvent(e);
    };

    var insertPromptTyping = function () {
      var $promptContainer = rootElement.querySelector('.c-zalo-text');
      var $typing = createElement('div', {
        classes: ['c-zalo-typing']
      });
      var $item = createElement('div');
      $typing.append($item);
      $typing.append($item.cloneNode());
      $typing.append($item.cloneNode());
      $promptContainer.append($typing);
    };

    var showPromptTyping = function () {
      var $promptContainer = rootElement.querySelector('.c-zalo-show');
      $promptContainer.querySelector('.c-zalo-text').innerHTML = '';
      insertPromptTyping();
      showPrompt({});
      var e = new Event('zalo.showPromptTyping');
      rootElement.dispatchEvent(e);
    };

    var hidePromptTyping = function () {
      var $promptContainer = rootElement.querySelector('.c-zalo-show');
      $promptContainer.classList.remove('active');
      var e = new Event('zalo.hidePromptTyping');
      rootElement.dispatchEvent(e);
    };

    contactZalo.init = function (options) {
      initPrompt();
      var e = new Event('zalo.init');
      rootElement.dispatchEvent(e);
    };

    contactZalo.showPromptTyping = function () {
      return showPromptTyping();
    };

    contactZalo.hidePromptTyping = function () {
      return hidePromptTyping();
    };

    contactZalo.showPrompt = function (data) {
      return showPrompt(data);
    };

    contactZalo.hidePrompt = function () {
      return hidePrompt();
    };

    return contactZalo;
  });


  function arCuShowMessage(index) {
    if (typeof arCuMessages[index] !== 'undefined') {
      contactZalo.showPromptTyping();

      _arCuTimeOut = setTimeout(function () {
        contactZalo.showPrompt({
          content: arCuMessages[index]
        });
        index++;
        _arCuTimeOut = setTimeout(function () {
          arCuShowMessage(index);
        }, arCuMessageTime);
      }, arCuTypingTime);
    } else {
      if (arCuCloseLastMessage) {
        contactZalo.hidePrompt();
      }
      if (arCuLoop) {
        arCuShowMessage(0);
      }
    }
  };

  function arCuShowMessages() {
    setTimeout(function () {
      clearTimeout(_arCuTimeOut);
      arCuShowMessage(0);
    }, arCuDelayFirst);
  }

  var arcuOptions;
  var _arCuTimeOut = null;

  var mess1 = document.querySelector('.mess-1').textContent;
  var mess2 = document.querySelector('.mess-2').textContent;
  var mess3 = document.querySelector('.mess-3').textContent;
  var arCuMessages = [mess1, mess2, mess3];
  var arCuLoop = false;
  var arCuCloseLastMessage = true;
  var arCuDelayFirst = 2000;
  var arCuTypingTime = 2000;
  var arCuMessageTime = 4000;

  window.addEventListener('load', function () {
    arcuOptions = {
      rootElementId: 'c-zalo',
    }

    contactZalo.init(arcuOptions);
    arCuShowMessages();

  });
}
